<template>
    <div>
        <primary-title id="title-wishlist">Lista de desejos</primary-title>
        
        <div class="mb-4"></div>

        <div class="product-intro row row-sm">
            <LoadingApp
                :is_full_page="true"
                :isLoading="isLoading"
            />
            <template v-if="itemsWishlist.length">
                <template v-for="item in itemsWishlist">
                    <ProductDefault
                        :key="item.id"
                        :pro="item"
                        layout_mode="list"
                        :page_wish_list="true"
                        :products_settings="products_settings"
                        @updateList="updateList"
                    >
                    </ProductDefault>
                </template>
            </template>
            <template v-else>
                <div
                    class="col-md-12"
                    style="display:flex; align-items:center;justify-content:center"
                >
                    <h3 style="color:#DB1;">
                        Sua lista de desejos esta vazia :(
                    </h3>
                </div>
            </template>
        </div>

        <Pagination
            :source="pagination"
            @navigate="navigate"
            :pagination_range="6"
        />
    </div>
</template>

<script>
import { CPrimaryTitle } from "../../components/Styles/Components/styled";
import ProductDefault from "../../components/product/ProductDefault.vue";
import { mapActions, mapState } from 'vuex';
import Pagination from '../../components/Pagination.vue'
import LoadingApp from '../../components/LoadingApp.vue'

export default {
    name: "Wishlist",
    props: {
        // products_settings: {
        //     default: null,
        //     required: true,
        // },
    },
    components: {
        ProductDefault,
        Pagination,
        LoadingApp,
        'primary-title': CPrimaryTitle
    },
    data() {
        return {
            isLoading: false,
            page: 1,
        }
    },
    mounted() {
        this.getList()
    },
    methods: {
        ...mapActions("wishlist", [
            "getListPaginate",
            "setItemsWishlist",
            "setPagination",
        ]),
        navigate(page = this.page) {
            this.page = page
            this.getList()
            let titleWishlist = document.querySelector('#title-wishlist')
            let sectionTitleWishlist = titleWishlist.getBoundingClientRect()
            window.scroll(0, sectionTitleWishlist.top + scrollY - titleWishlist.offsetHeight)
        },
        getList() {
            this.isLoading = true
            let filters = this.getFilters()

            this.getListPaginate(filters)
            .then(response => {
                this.isLoading = false
                this.setItemsWishlist(response.data.data)
                this.setPagination(response.data)
            })
            .catch(error => {
                this.isLoading = false
                console.log(error)
            })
        },
        getFilters() {
            return {
                page: this.page
            }
        },
        updateList() {
            if(this.itemsWishlist.length == 1 && this.page > 1) {
                this.page--
            }
            this.getList()
        }
    },
    computed: {
        ...mapState("wishlist", [
            "itemsWishlist",
            "pagination",
        ]),
        products_settings() {
            return this.$root.$children[0].$attrs.company?.products_settings ?? null
        }
    }
};
</script>
